export const EventName = {
    GetCloseBrowser: 'getCloseBrowser',
    GetOpenBrowser: 'getOpenBrowser',
    GetOpeningBrowser: "getOpeningBrowser",
    SendOpenBrowser: 'sendOpenBrowser',
    CloseBrowser: 'closeBrowser',
    UpdateStatusAccount: 'sendUpdateAccount',
    Notification: 'sendNotification',
    clearProfile: 'sendClearProfile',
    UpdateInfo: 'sendUpdateInfo',
    GetOpenOtherBrowser: 'sendOtherBrowser',
    convertBase64: 'sendConvertBase64',
    getConverBase64: 'convertBase64',
    openNewProcess: 'openNewProcess',
    uploadFile: "uploadFile",
    clearInterval: "clearInterval",
    startAuto: "startAuto",
    checkBrowser: "checkBrowser",
    downloadBrowser: "downloadBrowser",
    Upgrade: "upgrade",
    percentUpgrade: "percentUpgrade",
    addGroupFB: "addGroupFB",
    getCode: "getCode",
    checkCookie: "checkCookie",
    statusCheckCookie: "statusCheckCookie",
    deleteNotJoinGroup: "deleteNotJoinGroup",
    dataSyncGroup: "dataSyncGroup",
    addMultiGroupFB: "addMultiGroupFB"
};
